var _path, _path2, _path3, _path4, _g, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0067c6",
    d: "M0 0h53.3v40H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 13.3h53.3v13.4H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8a400",
    d: "M20.7 20h.6v-.1h-.2v-.3l.3-.2v-.2l-.3.3-.1-.2h-.2l-.1.2zm0-.1v-.4l.2-.1v.5zm0-1 .7.2.2-.7h-.1l-.2.6h-.2l.2-.6h-.1l-.2.5v-.6zm.3-.8.6.2v-.1h-.2l.1-.4v-.2l-.2-.1-.1.1-.1.3zm.1-.1.1-.3.1-.1h.1v.5zm.2-.7.4.2h.2l.2-.3V17l-.2-.2-.2-.1.3.3v.3l-.2.1-.2-.1-.2-.1m.5-.8.5.4.3-.3v-.3l-.1-.1h-.1l-.1-.1H22l-.2.3m.2 0 .1-.3h.2l-.1.3zm.2.1.2-.2v-.1l.2.1-.2.2v.1zm.2-.8.5.4.4-.3h-.1l-.3.2-.4-.4m.6-.6.4.6zm.6-.4-.2.2v.3l.2.2h.4l.1-.2-.2.2q-.3.1-.4 0l.1-.4h.3v-.1zm.8-.4v.8-.3l.4-.1.2.1zm0 .1.3.2-.2.1zM26 14v.7h.4l.2-.1v-.4l-.2-.2zm0 .1h.5v.5H26zm.9-.1v.7h.6l-.6-.1v-.2h.6l-.5-.1zh.5zm1.7.3-.2.6zl.2.7h.1l.3-.6H29l-.2.5-.3-.7m1 .4-.4.6.2-.7zm.4.3-.2-.1-.3.1v.4l.2.1.2.1h.2l-.1-.1h-.3q-.3-.3-.1-.4 0-.3.4 0l.1.2h.1V15zm.7.4-.7.3h.3l.2.2v.3l.2-.7m0 .2-.1.2-.2-.1zm.5.3-.6.4.1.1.2-.2.2.3v.4-.3h.3l.1-.2v-.2zm0 .1.2.3v.2h-.1l-.2-.2-.1-.1zm.7 1h-.7.3l.2.4-.2.2zm0 0-.2.3-.1-.2zm.5.8-.3-.2h-.3q-.2.2 0 .4v.4h.4L32 18h-.1v.2l-.2-.2v-.3h.3zv.3l.1-.1zm.2.6H32l-.2.1v.5l.1.1h.6V19l-.4.1q-.3 0-.2-.2l.1-.3zm.2 1.1-.7-.3v.1l.2.1v.4H32v.2l.7-.4zm-.1 0-.3.2v-.2zm-11.4 1.7H21v.5h.2zm11 0v.5H32zm-10 1.7-.7.1v.1h.3l.2.3-.1.2.4-.6m0 .1-.2.3-.1-.2zm.3.3-.5.5.5-.3-.2.6.6-.1-.4.3h.1l.5-.4H23l-.6.1.2-.5zm.7.7-.4.6.5.4V25l-.4-.3.2-.2.3.3h.1l-.4-.4.1-.1.4.3zm.6.5-.3.6h.1l.1-.2.3.2v.3h.2v-.3h.1v-.4zm0 .1.4.2v.2H24l-.1-.2zm.8.3-.2.6zm.6.2H25l-.3.2v.3l.3.2h.2l.2-.1H25q-.3 0-.2-.4 0-.2.4 0h.2v.1-.2zm.7.2-.5.6h.1l.2-.2h.3l.1.3h.1zm0 0 .1.4h-.3zm1.5 0h-.2l-.1.4v.2h.7v-.2l-.3.2q-.2 0-.3-.2t.2-.3h.3v-.1zm.5-.1.2.6.6-.1v-.1l-.6.1v-.2l.5-.1v-.1l-.5.1-.1-.1.5-.2zm.7-.2.3.6-.2-.6.7.3h.1l-.3-.6.2.5-.7-.3zm.7-.4v.1l.3-.1.3.4h.1l-.3-.5.3-.2zm.7-.4.5.5v-.1l-.1-.2.2-.2h.4l-.3-.1V24l-.2-.1-.2.1zm.1 0 .3-.3h.2v.1l-.2.3h-.1zm.7-.8.3.7V24l.2-.3h.2zm0 0h.4l-.2.3zm.3-.4.5.4.3-.5-.3.3z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 9,
    height: 8,
    x: 22,
    y: 15,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.7 15-4.3 7.4H31z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.7 15-2.1 3.7-1 1.8h6.2l-1-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m26.7 15-.2.4.2 3.6.1-3.6z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.7 18.5v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M30.4 17.8h-.3L26.7 19l3.5-1z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.2 18.9H27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M29 22.2V22l-2.3-3 2 3.1z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27 19.5-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m24.4 22.2.2-.1 2-3-2.2 2.8z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.4 19.5v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m23 17.8.1.3 3.6 1-3.5-1.4z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.2 18.9h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m27.2 15.1-.2.3-.3 3.6.6-3.6z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.7 18.5v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M30.5 18.3h-.2l-3.6.7 3.6-.4z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.2 19H27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M28.5 22.5v-.3L26.7 19l1.6 3.4z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27 19.5-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m24 21.9.2-.1 2.5-2.8-2.7 2.6z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.3 19.4.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m23.1 17.3.2.3 3.4 1.4-3.3-1.7z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.2 18.8h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m27.8 15.2-.3.3-.8 3.5 1.1-3.5z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.8 18.5v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m30.6 18.9-.3-.2-3.6.3h3.6z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.2 19H27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M28 22.7v-.3L26.8 19l1 3.5z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.8 19.5v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M23.6 21.5h.3l2.8-2.5-3 2.2z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.2 19.4.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m23.4 16.8.1.3 3.2 2-3-2.3z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.2 18.7.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m28.3 15.4-.3.2-1.3 3.4 1.6-3.3z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.9 18.5-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m30.6 19.4-.3-.1-3.6-.3 3.6.6z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.2 19H27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M27.5 22.9v-.3l-.8-3.6.6 3.7z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.8 19.6v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M23.3 21h.3l3-2-3.2 1.7z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.2 19.3.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m23.7 16.4.1.3 2.9 2.3-2.7-2.5z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.3 18.7.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m28.8 15.7-.3.1-1.8 3.2 2-3z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27 18.6-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m30.5 20-.2-.2-3.6-.8 3.5 1z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.2 19.2H27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M27 23v-.3l-.3-3.7v3.7z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.7 19.6v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M23 20.5h.3l3.4-1.5-3.5 1.3z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.2 19.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M24.1 16v.3l2.6 2.7-2.3-2.9z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.3 18.6.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m29.2 16-.3.1-2.2 3 2.5-2.8z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27 18.6-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m30.3 20.5-.2-.2-3.4-1.3 3.3 1.6z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.2 19.2H27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m26.4 23 .2-.3V19l-.3 3.7z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.6 19.6v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M22.8 20h.3l3.6-1-3.6.8z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.1 19.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M24.6 15.7v.3l2 3-1.7-3.2z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.4 18.6v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M29.6 16.4h-.3L26.7 19l2.8-2.3z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27 18.7v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M30 21v-.3L26.6 19l3 2z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27.1 19.3-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m25.8 22.9.3-.2.6-3.7-1 3.6z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.6 19.6v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m22.7 19.4.3.2 3.7-.6-3.7.3z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.1 19h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M25 15.4v.3l1.7 3.3-1.4-3.4z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.4 18.5.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M30 16.8h-.4l-3 2.2 3.2-1.9z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27.1 18.7-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m29.8 21.5-.1-.3-3-2.2 2.8 2.4z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27 19.4v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m25.3 22.7.3-.2 1-3.5-1.3 3.4z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.5 19.5v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m22.7 18.9.3.2h3.7l-3.7-.4z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.1 19h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m25.6 15.2-.1.3 1.2 3.5-.9-3.5z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.5 18.5v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M30.2 17.3H30L26.7 19l3.3-1.4z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.1 18.8H27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "M29.4 21.9v-.3L26.6 19l2.4 2.8z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27 19.4-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m24.8 22.5.3-.1 1.6-3.4-1.9 3.2z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.4 19.5.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m22.8 18.3.2.3 3.7.4-3.6-.8z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.1 19h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17c0eb",
    d: "m26.1 15.1-.1.3.7 3.6-.4-3.6z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.6 18.5v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M26.7 17.7a3 3 0 0 0-2 .7l-1 1.7v.6h.3a2.6 2.6 0 0 1 5.3 0h.3V20l-1-1.7a3 3 0 0 0-2-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f60",
    d: "M26.7 17.8q-1.2 0-2 .8l-.9 1.4v.7h.2a2.6 2.6 0 0 1 5.3 0h.3l-.1-.7-.8-1.4q-1-.8-2-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M26.7 17.8a3 3 0 0 0-2.2 1l-.5 1-.2.9h.2a2.6 2.6 0 0 1 5.3 0h.2l-.1-1-.6-1a3 3 0 0 0-2.1-.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0f0",
    d: "M26.7 17.9a3 3 0 0 0-2.4 1.2l-.1.4q-.3.5-.3 1.2h.1a2.6 2.6 0 0 1 5.3 0h.2q0-.7-.3-1.2L29 19a3 3 0 0 0-2.3-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0cf",
    d: "M26.7 18a2.7 2.7 0 0 0-2.8 2.7h.1a2.6 2.6 0 0 1 5.3 0h.1a2.7 2.7 0 0 0-2.7-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00f",
    d: "M26.7 18a2.7 2.7 0 0 0-2.7 2.7 2.6 2.6 0 1 1 5.3 0 3 3 0 0 0-2.6-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "purple",
    d: "M26.7 18a2.6 2.6 0 0 0-2.7 2.7 2.6 2.6 0 0 1 5.3 0 2.6 2.6 0 0 0-2.6-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#510000",
    d: "M26.7 19.2h-.1v.4h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M26.5 18.9h-.2l.2-.2h.3l.2.4v.1h-.6V19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m26.5 18.8-.1.1zl-.1.2v.2l.3.1h.2v-.1h-.3v-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff2a2a",
    d: "M26.7 18.7v.1h.1v.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M26.8 19.2h-.2l-.2-.1.2.2v.3h.2v-.2h.2v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#910000",
    d: "m26.6 19.3-.2-.1V19l.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff3a3a",
    d: "M26.8 19.4h.2v-.1zl-.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m23.5 20.5-.6 1.2h7.6l-.7-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M23.3 21.4H23v.1h7.4-7.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M23.3 21.4H23h7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M23.3 21.3H23h7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M23.3 21.2H23h7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M23.3 21.1H23v.1h7.4-7.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M23.3 21H23v.1h7.4-7.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M23.3 21H23h7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M23.3 21H23h7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M23.3 20.8H23v.1h7.4-7.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M23.5 20.5h6.3zm0 0h6.3zm0 0h6.3zm0 0v.1h6.4zm0 .1h6.4zm0 0h6.4zm0 .1h6.4zm-.1 0v.1H30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M23.8 20.8h.3zm5.5 0h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M28.7 19.8h-.1q-.4 1.4-1.5 1.5h-.6v.7h4.1l-.4-.7q-1-.3-1.3-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97c924",
    d: "M28.7 19.8h-.1q-.2.6-.6 1t-1 .5h-.5v.7h4.1l-.4-.7q-.5 0-.8-.4-.5-.5-.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ede71f",
    d: "M28.7 19.8v.8l-.1.4-.2.2h-1l.8-.5.2-.3v-.1l.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6cb24",
    d: "M28.7 20q0 .6-.5 1.1l-.4.2q.8-.7.9-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ecb34",
    d: "M28.3 20.6q0 .3-.6.7h-.2q.4 0 .8-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M27.7 19.8h-.2q-.2 1.4-1.5 1.5h-.5v.7h4l-.3-.7q-1-.3-1.4-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97c924",
    d: "M27.7 19.8h-.1q-.2.6-.6 1t-1 .5h-.5v.7h4l-.3-.7q-.5 0-.8-.4-.5-.5-.6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ede71f",
    d: "M27.7 19.8v.8l-.1.4-.2.2h-1l.7-.5.2-.3.1-.1.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6cb24",
    d: "M27.6 20q0 .6-.4 1.1l-.4.2q.7-.7.8-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ecb34",
    d: "M27.3 20.6q0 .3-.6.7h-.2q.4 0 .8-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M26.8 19.9q.4 1.2 1.5 1.4h.6v.7h-4.4v-.7h.5q1.1-.2 1.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97c924",
    d: "m26.7 19.8.6 1q.4.5 1 .5h.5v.7h-4.3v-.7h.5q.6 0 1-.4t.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ede71f",
    d: "m26.6 19.8-.1.3-.2.3-.3.5-.7.4h.5l.4-.1V21l.3-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6cb24",
    d: "M26.6 20q0 .6-.4 1.1l-.4.2q.7-.7.8-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ecb34",
    d: "m26.3 20.6-.6.7h-.2q.3 0 .8-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ede71f",
    d: "m26.7 19.8.2.5.1.1.3.5.7.4q-.7 0-.9-.3l-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6cb24",
    d: "M26.8 20q0 .5.4 1l.4.2a2 2 0 0 1-.8-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M25.7 19.8h-.2q-.4 1.3-1.4 1.6l-.4.6H27v-.8q-.9-.3-1.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97c924",
    d: "M25.7 19.8h-.2q-.1.6-.5 1-.4.6-1 .7l-.2.5H27v-.7l-.7-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93bc30",
    d: "M25.6 20c0 .5-.4 1.3-.8 1.4h-.4a2 2 0 0 0 1.2-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ede71f",
    d: "M25.7 19.8V21l.2.2q.5.3 1 .3l-.2-.2h.3l-.8-.5v-.1l-.3-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccd11e",
    d: "M25.7 20q0 .6.4 1.1l.4.2q-.6-.6-.8-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ecb34",
    d: "M26 20.5q.3.6 1 1h.1q-.6-.2-1.1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M24.6 19.8h-.1q-.4 1.3-1.5 1.6l-.3.6H26v-.8q-1-.2-1.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97c924",
    d: "m24.6 19.8-.5 1q-.5.6-1 .7l-.3.5H26v-.7l-.6-.4-.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93bc30",
    d: "M24.5 20c0 .5-.3 1.3-.7 1.4h-.4a2 2 0 0 0 1.1-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ede71f",
    d: "M24.6 19.8v.8l.1.4.2.2q.4.3 1 .3l-.2-.2h.3l-.8-.5v-.1l-.3-.4-.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6cb24",
    d: "M24.7 20q0 .6.4 1.1l.4.2q-.6-.6-.8-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ecb34",
    d: "M25 20.5q.3.6 1 1-.4-.2-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.4 21.6h-.7l-.7.1h-6.2l-.4.7H31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "m29.9 21.5-.8.1h-2.5l-.8.1h-2.4l-.6.1v.1h1.6l.8-.1h2.2l.6-.1h2.5v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M23.4 22.3h-.9v.1h8.3-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M23.4 22.2h-.9v.1h8.3-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "m23.4 22.1-.7.1h-.2 8.3-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "m23.4 22-.7.1h-.2 8.3-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M23.4 22h-.9 8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M23.4 21.9h-.9 8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M23.4 21.8h-.9v.1h8.3-.2l-.6-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M23.4 21.7h-.9v.1h8.3-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M23.4 21.6h-.9v.1h8.3-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97c924",
    d: "m23 21.6-.2.3h1.5l.7-.1h2.5l.7-.2.9.1h1.3l-.1-.3-6.8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 21.6h.5z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8a400",
    d: "m26.7 15-2.2 3.7-2.2 3.8H31l-2.1-3.7zm0 .2 2 3.6 2.1 3.6h-8.3l2.1-3.6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 26.6,
    x2: 26.7,
    y1: 19.3,
    y2: 18.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#510000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8a0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 26.8,
    x2: 26.9,
    y1: 19.4,
    y2: 19.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff2a2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 23,
    x2: 35.6,
    y1: 21.2,
    y2: 21.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 23,
    x2: 35.6,
    y1: 21.1,
    y2: 21.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 23,
    x2: 35.6,
    y1: 21,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 23,
    x2: 35.6,
    y1: 20.9,
    y2: 20.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 23,
    x2: 35.6,
    y1: 20.9,
    y2: 20.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 23,
    x2: 35.6,
    y1: 20.8,
    y2: 20.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 23,
    x2: 35.6,
    y1: 20.7,
    y2: 20.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 23,
    x2: 35.6,
    y1: 20.6,
    y2: 20.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 23,
    x2: 35.6,
    y1: 20.6,
    y2: 20.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 23,
    x2: 35.6,
    y1: 21.2,
    y2: 21.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 23,
    x2: 35.6,
    y1: 21.2,
    y2: 21.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 25.7,
    x2: 25.7,
    y1: 20.8,
    y2: 21.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5f549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97c924"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 24.6,
    x2: 24.6,
    y1: 20.8,
    y2: 21.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5f549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97c924"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 25.7,
    x2: 25.7,
    y1: 20.8,
    y2: 21.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5f549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97c924"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 25.7,
    x2: 25.7,
    y1: 20.8,
    y2: 21.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5f549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97c924"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 24.6,
    x2: 24.6,
    y1: 20.8,
    y2: 21.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5f549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97c924"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 22.7,
    x2: 30.5,
    y1: 21.5,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 22.5,
    x2: 30.9,
    y1: 22.3,
    y2: 22.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 22.5,
    x2: 30.9,
    y1: 22.2,
    y2: 22.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 22.5,
    x2: 30.9,
    y1: 22.1,
    y2: 22.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 22.5,
    x2: 30.9,
    y1: 22.1,
    y2: 22.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 22.5,
    x2: 30.9,
    y1: 22,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 22.5,
    x2: 30.9,
    y1: 21.9,
    y2: 21.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 22.5,
    x2: 30.9,
    y1: 21.8,
    y2: 21.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 22.5,
    x2: 30.9,
    y1: 21.7,
    y2: 21.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 22.5,
    x2: 30.9,
    y1: 21.6,
    y2: 21.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNi);
export default __webpack_public_path__ + "static/media/ni.c1886ff2e43f54d24d6922e1f2f62156.svg";
export { ForwardRef as ReactComponent };